module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/44SswI/tc-custom/9781781266243.jpg?1706683676952",
      "alt": "This image is the cover for the book Twenty to Knit: Pocket Pets, Twenty to Make"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Twenty to Knit: Pocket Pets, Twenty to Make\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Make your own collection of irresistibly cute knitted animals in soft, fleecy yarn. This gorgeous knitting book for knitters of all abilities by Sachiyo Ishii contains 20 lovely projects including a baby penguin, a koala bear, a guinea pig and a squirrel. All the projects are accompanied by clear, easy-to-follow patterns and photography. There is a useful page of basic techniques at the start of the book, including making up, stuffing, and simple, decorative surface stitching.  These lovely mini knits are all bursting with character and feel extra soft and snuggly.   All the projects are exquisitely designed and very easy to make. They make perfect gifts and will delight young and old alike.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sachiyo Ishii\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Search Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0